import { render, staticRenderFns } from "./IconChevronDown.vue?vue&type=template&id=853449fe&"
import script from "./IconChevronDown.vue?vue&type=script&lang=js&"
export * from "./IconChevronDown.vue?vue&type=script&lang=js&"
import style0 from "./IconChevronDown.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports